import './override/lib-jitsi-meet/index.js';
import { isMobileBrowser } from '../react/features/base/environment/utils';
import Helpers from './modules/Helpers';
import WildixActions from './modules/WildixActions';
import WildixEvents from './service/WildixEvents';

import { iAmVisitor } from '../react/features/visitors/functions';

import EventManager from './EventManager';
import Env from './modules/Environment';
import OverrideExports from './modules/OverrideExports';
import Recording from './modules/Recording';
import ControlManager from './modules/ScreenControl/ControlManager';
import SpeakersInfo from './modules/SpeakersInfo';
import Storage from './modules/Storage';
import SiteTutorial from './modules/Tutorial/SiteTutorial';
import WIService from './modules/WIService';
import WildixMethods from './modules/WildixMethods';
import Wizy from './wizyconf';

const EventEmitter = require('events');


if (isMobileBrowser()) {
    const root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)

    root.setAttribute('class', 'mobile');
}


export default class Wildix {

    constructor() {
        this.storage = new Storage();
        this.methods = new WildixMethods();
        this.wildixActions = new WildixActions();
        this.recording = new Recording();
        this.eventEmitter = new EventEmitter();
        this.eventManager = new EventManager(this.eventEmitter, this.methods);
        this.eventManager.init();
        this.wiservice = new WIService();
        this.speakersInfo = new SpeakersInfo();
        this.override = new OverrideExports();
        this.helpers = new Helpers();

        if (Env.isWizyconf()) {
            this.wizy = new Wizy();
        }

        document.addEventListener(WildixEvents.CONFERENCE_JOINED, () => {
            if (iAmVisitor(APP.store.getState)) {
                return;
            }
            if (!isMobileBrowser() || !Env.isWizyconf()) {
                this.controlSharing = new ControlManager();
            }
            if (!isMobileBrowser()) {
                this.tutorial = new SiteTutorial();
            }
        });
    }

}
